export const FAQ_INFO_DATA = {
  title: 'Thông tin cơ bản',
  subItems: [
    {
      id: 'basic-info',
      title: "",
      contentItems: [
        {
          id: 'cau-1',
          title: "Cách liên hệ với GooPay",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể liên lạc với bộ phận Chăm Sóc Khách Hàng (CSKH) qua một trong các kênh sau:</p>
              <ol className="mt-2 space-y-1">
                <li>1. Gửi yêu cầu hỗ trợ trên mục Trợ giúp của ứng dụng GooPay (Đề xuất)</li>
                <li>2. Liên hệ theo Hotline: 19006038</li>
                <li>3. Gửi yêu cầu đến email <span className="text-[#0073DD] underline">cskh@goopay.vn</span></li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Sử dụng GooPay có mất phí không?",
          content: (
            <div>
              <p className="text-gray-700">Bạn yên tâm vì khi sử dụng Ví GooPay bạn sẽ không cần phải lo lắng về phí duy trì hay bất kỳ khoản phí ẩn nào. Tuy nhiên, có một vài trường hợp đặc biệt có thể phát sinh phí, cụ thể là:</p>
              <p className="text-gray-700 mt-2"><strong>Phí rút tiền về ngân hàng:</strong> Miễn phí nếu tổng số tiền bạn rút trong tháng không quá 30 triệu đồng.</p>
              <p className="text-gray-700 mt-1">Nếu vượt quá 30 triệu đồng trong tháng, phí sẽ là 0,5% nhân với giá trị giao dịch.</p>
              <p className="text-gray-700 mt-1">Nếu vượt quá 100 triệu đồng trong tháng, phí sẽ là 1% nhân với giá trị giao dịch.</p>
              <p className="text-gray-700 mt-2">Ngoài ra, một số dịch vụ đặc biệt khác trên Ví GooPay cũng có thể có phí riêng.</p>
              <p className="text-gray-700 mt-2">Bạn nên kiểm tra kỹ thông tin trước khi sử dụng.</p>
              <p className="text-gray-700 mt-2">Nếu có bất kỳ thắc mắc nào khác về phí dịch vụ, đừng ngần ngại liên hệ với GooPay qua hotline hỗ trợ 19006038. GooPay luôn sẵn sàng giải đáp mọi câu hỏi của bạn!</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Thanh toán bằng Ví GooPay có được chiết khấu không?",
          content: (
            <div>
              <p className="text-gray-700">Nạp tiền điện thoại và mua mã thẻ di động trên GooPay luôn được chiết khấu trên giá trị giao dịch là 3% với nhà mạng Viettel và 5% với các nhà mạng Mobifone, Vinaphone, Vietnammobile, Gmobile.</p>
              <p className="text-gray-700 mt-2">Thanh toán các dịch vụ khác trên GooPay có thể có hoặc không có chiết khấu tùy vào nhà cung cấp dịch vụ và tùy từng thời điểm.</p>
            </div>
          )
        },
        {
          id: 'cau-4',
          title: "Hạn mức giao dịch mỗi ngày?",
          content: (
            <div>
              <p className="text-gray-700">Hạn mức giao dịch của tài khoản GooPay tùy thuộc vào tình trạng tài khoản đã được xác thực bằng thẻ/tài khoản ngân hàng hay chưa. Cụ thể:</p>
              <div className="mt-2">
                <p className="text-gray-700"><strong>Tài khoản GooPay có xác thực bằng thẻ/tài khoản ngân hàng:</strong></p>
                <ul className="mt-1 space-y-1">
                  <li>Số dư trong GooPay tối đa: 200.000.000đ</li>
                  <li>Số tiền nạp vào GooPay tối đa 50.000.000vnđ/ngày bằng hình thức nạp tiền từ Ngân Hàng tối đa 100.000.000đ/ngày bằng hình thức Chuyển tiền Ví -Ví</li>
                  <li>Số tiền rút ra khỏi GooPay hoặc thanh toán trên GooPay tối đa 50.000.000đ/ngày</li>
                  <li>Không giới hạn số lượt giao dịch có thể thực hiện</li>
                </ul>
              </div>
              <div className="mt-2">
                <p className="text-gray-700"><strong>Tài khoản GooPay chưa xác thực bằng thẻ/tài khoản ngân hàng:</strong> Tài khoản này không thể sử dụng nguồn tiền GooPay trong ví.</p>
              </div>
              <div className="mt-2">
                <p className="text-gray-700"><strong>Hạn mức thanh toán bằng thẻ:</strong> tối đa 10.000.000đ/giao dịch/ngày</p>
                <p className="text-gray-700">Không giới hạn số lượt giao dịch có thể thực hiện</p>
              </div>
              <p className="text-gray-700 mt-2">Bạn có thể mở hạn mức giao dịch bằng cách liên kết ví GooPay với thẻ/tài khoản ngân hàng, xem hướng dẫn cách liên kết tại đây.</p>
            </div>
          )
        },
        {
          id: 'cau-5',
          title: "Tiền trong tài khoản GooPay có phải tiền thật?",
          content: (
            <div>
              <p className="text-gray-700">Tiền trong tài khoản GooPay có giá trị như tiền mặt và được bảo chứng 100% bởi các Ngân Hàng đang hợp tác với Ví GooPay. Bạn hoàn toàn có thể nạp/ rút tiền dễ dàng qua tài khoản của các ngân hàng liên kết.</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "GooPay là gì?",
          content: (
            <div>
              <p className="text-gray-700">Ứng dụng Ví điện tử GooPay là sản phẩm của Công ty cổ phần Thanh toán Trực tuyến Toàn Cầu (GooPay). Ứng dụng cho phép bạn tạo và nạp tiền vào tài khoản GooPay để thanh toán cho hơn 50 dịch vụ như mua vé xe khách Futa BusLines, thanh toán Futa Express, nạp tiền điện thoại, thanh toán điện nước, thanh toán vay tiêu dùng, v.v...</p>
              <p className="text-gray-700 mt-2">GooPay là đối tác chiến lược của Vietcombank, OCB, VPBank, Vietinbank, TPBank, ACB, Eximbank, Sacombank, VIB, BIDV và Shinhan Bank. Từ ngày 25/11/2021, GooPay được Ngân hàng Nhà nước Việt Nam cấp giấy phép cung cấp dịch vụ Ví điện tử số 16/GP-NHNN.</p>
            </div>
          )
        },
        {
          id: 'cau-7',
          title: "GooPay cũng có những dịch vụ gì?",
          content: (
            <div>
              <p className="text-gray-700">GooPay có hơn 50 dịch vụ cho bạn tha hồ lựa chọn như:</p>
              <ol className="mt-2 space-y-1">
                <li>1. Chuyển tiền cho người khác qua số điện thoại</li>
                <li>2. Mua vé xe liên tỉnh FUTA Bus Line (Phương Trang)</li>
                <li>3. Thanh toán chuyển phát nhanh Phương Trang FUTA</li>
                <li>4. Mua vé xe Bus Phương Trang</li>
                <li>5. Giao dịch trên sàn funong.vn</li>
                <li>6. Nạp tiền điện thoại, mua mã thẻ di động</li>
                <li>7. Thanh toán điện nước</li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-8',
          title: "Ví điện tử là gì?",
          content: (
            <div>
              <p className="text-gray-700">Ví điện tử hay còn được gọi là Ví tiền trực tuyến (online) là một tài khoản thanh toán các giao dịch trực tuyến phổ biến nhất hiện nay như: mua vé xe khách, thanh toán tiền điện, nước, học phí, nạp tiền điện thoại (Top Up), mua vé xe bus, mua sắm trực tuyến,...</p>
              <p className="text-gray-700 mt-2">Chức năng hoạt động của Ví điện tử thực hiện bằng cách Liên kết Tài Khoản ngân hàng (Xem danh sách ngân hàng), nạp tiền vào Ví và thanh toán bất kì dịch vụ có liên kết một cách đơn giản, tiện lợi.</p>
              <p className="text-gray-700 mt-2">Chỉ cần bạn có Smartphone, mạng Wifi và tài khoản đã có thể thực hiện mọi giao dịch ở mọi nơi.</p>
            </div>
          )
        },
        {
          id: 'cau-9',
          title: "Sử dụng GooPay có an toàn?",
          content: (
            <div>
              <p className="text-gray-700">Bạn hoàn toàn yên tâm khi sử dụng GooPay, vì 4 lý do:</p>
              <ol className="mt-2 space-y-2">
                <li><strong>Bảo chứng bởi ngân hàng:</strong> Tiền trong tài khoản GooPay được bảo chứng bởi BIDV và ngân hàng liên kết với tài khoản của bạn. được Ngân hàng Nhà nước cấp giấy phép và quản lý.</li>
                <li><strong>Mạng lưới bảo mật đa tầng:</strong> Mỗi bước giao dịch của bạn đều được GooPay mã hóa và bảo vệ ngay tức thì. GooPay tự khóa ứng dụng nếu không được sử dụng trong vòng 5 phút và sử dụng công nghệ thông minh để tự động nhận diện và ngăn chặn giao dịch đáng ngờ.</li>
                <li><strong>Hỗ trợ đa kênh 24/7:</strong> Trung tâm Chăm sóc khách hàng của GooPay sẵn sàng phục vụ 24/7, kể cả ngày nghỉ để hỗ trợ khách hàng.</li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-10',
          title: "Quy trình khiếu nại với bộ phận CSKH",
          content: (
            <div>
              <p className="text-gray-700"><strong>Bước 1: Tạo yêu cầu hỗ trợ/ khiếu nại</strong></p>
              <p className="text-gray-700">Xem ngay tại:........</p>
              <p className="text-gray-700 mt-2"><strong>Bước 2: CSKH tiếp nhận thông tin và xử lý</strong></p>
              <p className="text-gray-700">Khi tiếp nhận thông tin, nhân viên CSKH có thể yêu cầu bạn cung cấp các thông tin liên quan tùy theo bản chất khiếu nại của bạn. Xin lưu ý rằng CSKH sẽ không bao giờ yêu cầu bạn cung cấp số OTP và mật khẩu tài khoản GooPay.</p>
              <p className="text-gray-700 mt-2">Kể từ lúc bạn gửi yêu cầu hỗ trợ/ khiếu nại, CSKH sẽ xử lý trong vòng 24 giờ. Tuy nhiên trong một số trường hợp khi vấn đề khiếu nại cần thêm thời gian để xử lý, nhân viên CSKH sẽ thông báo với bạn về thời gian dự kiến hoàn thành.</p>
              <p className="text-gray-700 mt-2"><strong>Bước 3: CSKH phản hồi kết quả</strong></p>
              <p className="text-gray-700">Bộ phận CSKH sẽ chủ động liên hệ bạn theo 1 trong 3 hình thức sau:</p>
              <ol className="mt-2 space-y-1">
                <li>Gửi tin nhắn trên ứng dụng GooPay</li>
                <li>Gửi tin nhắn SMS tới số điện thoại bạn sử dụng để liên hệ CSKH</li>
                <li>Gọi điện thoại trực tiếp đến bạn</li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-11',
          title: "Tải ứng dụng Ví GooPay",
          content: (
            <div>
              <p className="text-gray-700">Tìm từ khóa "GooPay" trên App Store hoặc Google Play Store, và làm theo hướng dẫn.</p>
            </div>
          )
        },
        {
          id: 'cau-12',
          title: "Tài khoản GooPay là gì?",
          content: (
            <div>
              <p className="text-gray-700">Số tài khoản GooPay chính là số điện thoại bạn đã dùng để đăng kí tài khoản GooPay đó. Mỗi tài khoản GooPay tương ứng với duy nhất 1 số điện thoại, và mỗi số điện thoại cũng chỉ đăng ký được duy nhất 1 tài khoản GooPay.</p>
            </div>
          )
        },
        {
          id: 'cau-13',
          title: "Dịch vụ liên kết là gì?",
          content: (
            <div>
              <p className="text-gray-700">Dịch vụ liên kết là luồng thanh toán cho phép khách hàng thiết lập một lần duy nhất giữa Ví GooPay và nhà cung cấp dịch vụ. Các thông tin thanh toán sẽ được mã hóa và lưu lại cho các lần giao dịch tiếp theo và người dùng sẽ không cần phải xác nhận sau mỗi giao dịch như luồng thanh toán thông thường.</p>
              <p className="text-gray-700 mt-2">Việc liên kết Ví GooPay cũng tương tự như việc lưu thẻ ngân hàng làm phương thức thanh toán trên các trang thương mại điện tử, đặt vé xe khách, v.v., giúp cho việc thanh toán trở nên nhanh chóng và dễ dàng hơn.</p>
              <p className="text-gray-700 mt-2">Khi đã liên kết Ví GooPay, người dùng cần quản lý các dịch vụ gia hạn tự động (nếu có), duy trì số dư, và điều chỉnh hạn mức phù hợp với nhu cầu thanh toán, mua sắm.</p>
            </div>
          )
        },
        {
          id: 'cau-14',
          title: "Các cách quản lý dịch vụ liên kết?",
          content: (
            <div>
              <p className="text-gray-700">Với các dịch vụ liên kết, bạn có thể điều chỉnh hạn mức phù hợp với nhu cầu mua sắm, tạm dừng, hoặc hủy liên kết bằng cách vào Ví của tôi &gt; Dịch vụ liên kết.</p>
              <p className="text-gray-700 mt-2">Khi tạm dừng liên kết, nhà cung cấp dịch vụ sẽ không thể tiếp tục yêu cầu thanh toán qua Ví GooPay. Đây là cách nhanh nhất để dừng các khoản thanh toán không mong muốn. Bạn cũng có thể tiếp tục liên kết bất cứ lúc nào.</p>
              <p className="text-gray-700 mt-2">Khi huỷ liên kết, nhà cung cấp dịch vụ sẽ không thể tiếp tục yêu cầu thanh toán qua Ví GooPay. Nếu muốn sử dụng GooPay làm phương thức thanh toán, bạn sẽ cần thiết lập lại liên kết từ phía nhà cung cấp dịch vụ.</p>
            </div>
          )
        },
        {
          id: 'cau-15',
          title: "Làm thế nào để biết giao dịch đã thành công?",
          content: (
            <div>
              <p className="text-gray-700">GooPay sẽ gửi thông báo ngay sau khi giao dịch thành công. Bạn có thể xem lại thông báo khi nhấp vào biểu tượng Quả chuông tại góc phải trên cùng ở màn hình chính.</p>
              <p className="text-gray-700 mt-2">Đồng thời bạn có thể kiểm tra số dư tài khoản hoặc vào mục "Lịch sử giao dịch" từ màn hình chính để biết chính xác kết quả giao dịch của mình.</p>
            </div>
          )
        },
        {
          id: 'cau-16',
          title: "Cách nạp tiền vào GooPay",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể nạp tiền vào tài khoản GooPay thông qua các hình thức sau:</p>
              <ol className="mt-2 space-y-2">
                <li><strong>Từ tài khoản của các ngân hàng liên kết với GooPay:</strong> Vietcombank, Vietinbank, Agribank, BIDV, ACB, TPBank, VPBank, Eximbank, OCB, VIB, Shinhan Bank, SCB, Thẻ nội địa Sacombank, VRB, BAOVIET Bank, ABBANK, OceanBank, MBBank, PVcomBank, VietCapital Bank, Nam Á Bank, SHB, Bac A Bank, HDBank, SAIGONBANK (Hoàn toàn miễn phí)</li>
                <li><strong>Từ thẻ ATM của 30 ngân hàng thuộc hệ thống Napas.</strong> (Hoàn toàn miễn phí.)<br/><em>Lưu ý:</em> với 2 hình thức trên bạn cần đăng ký dịch vụ thanh toán trực tuyến (Internet Banking) & sử dụng phương thức xác thực bằng SMS của ngân hàng.</li>
                <li><strong>Nhận tiền từ 1 tài khoản GooPay khác</strong> chuyển đến tài khoản GooPay của bạn.</li>
              </ol>
            </div>
          )
        },
        {
          id: 'cau-17',
          title: "Làm thế nào để kiểm tra thông tin đơn hàng và tìm trợ giúp sau khi mua hàng?",
          content: (
            <div>
              <p className="text-gray-700">Bạn có thể vào phần Lịch sử GD, chọn giao dịch liên quan bằng cách sử dụng ô tìm kiếm hoặc bộ lọc để thao tác nhanh hơn, chọn phần Trợ giúp ở cuối để giải đáp các vấn đề thường gặp. Tại đây bạn cũng có thể gửi yêu cầu trợ giúp nếu cần hỗ trợ thêm.</p>
            </div>
          )
        },
        {
          id: 'cau-18',
          title: "Rút tiền từ GooPay về tài khoản ngân hàng liên kết có mất phí không?",
          content: (
            <div>
              <p className="text-gray-700">Khi rút tiền từ GooPay về tài khoản Ngân hàng liên kết, bạn sẽ được <strong>MIỄN PHÍ</strong> rút tiền cho <strong>10 GIAO DỊCH RÚT TIỀN ĐẦU TIÊN TRONG THÁNG</strong>, tối đa đến <strong>50 triệu đồng/tháng</strong>.</p>
              <p className="text-gray-700 mt-2">Với giao dịch Rút tiền từ lần thứ 11 (hoặc hết hạn mức) sẽ tính mức phí <strong>3.300Đ + 0,65% x Giá trị giao dịch</strong>.</p>
            </div>
          )
        },
        {
          id: 'cau-19',
          title: "Vì sao cần xác thực email?",
          content: (
            <div>
              <p className="text-gray-700">Sau bước tạo tài khoản với GooPay, GooPay sẽ gửi email đến địa chỉ email đã nhập của bạn để xác nhận đây đúng là địa chỉ email của bạn. Sau khi đã xác thực email, bạn sẽ nhận được các thông tin liên quan tới bảo mật tài khoản trong các trường hợp như:</p>
              <ul className="mt-2 space-y-1">
                <li>Cảnh báo tài khoản được đăng nhập trên thiết bị khác</li>
                <li>Lấy lại mật khẩu khi bạn có yêu cầu</li>
                <li>Thông tin kết quả giao dịch</li>
              </ul>
            </div>
          )
        }
      ]
    }
  ]
}; 